import { defineComponent as _defineComponent } from 'vue'
import { InfoTooltipIcon } from '../../icons/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'TooltipComponent',
  props: {
  text: {
    type: String,
    default: '',
  },
},
  setup(__props) {



return { __sfc: true,InfoTooltipIcon }
}

})